'use client';

import { Check } from 'lucide-react';

interface StepIndicatorProps {
  currentStep: number;
  stepLabel: string;
  hidden: boolean;
  onStepClick: (step: number) => void;
  navigationDisabled: boolean;
}

export function StepIndicator({
  currentStep,
  stepLabel,
  hidden,
  onStepClick,
  navigationDisabled,
}: StepIndicatorProps) {
  return (
    <div className={`border-b border-stone-800/50 bg-stone-950 ${hidden ? 'hidden' : ''}`}>
      {/* Desktop: circle buttons with check marks */}
      <div className="hidden items-center gap-2 px-6 py-4 md:px-12 lg:px-16 lg:pt-8 lg:pb-0 md:flex">
        {[1, 2, 3, 4].map((step) => (
          <div key={step} className="flex items-center">
            <button
              onClick={() => step < currentStep && onStepClick(step)}
              disabled={step > currentStep || navigationDisabled}
              className={`
                w-9 h-9 rounded-full flex items-center justify-center font-semibold text-sm transition-all
                ${
                  step === currentStep
                    ? 'bg-dgd-gold text-stone-950'
                    : step < currentStep
                      ? `bg-dgd-gold/20 text-dgd-gold ${
                          navigationDisabled
                            ? 'cursor-not-allowed opacity-60'
                            : 'hover:bg-dgd-gold/30 cursor-pointer'
                        }`
                      : 'bg-stone-800 text-stone-500'
                }
              `}
            >
              {step < currentStep ? <Check className="w-4 h-4" /> : step}
            </button>
            {step < 4 && (
              <div
                className={`w-8 h-0.5 mx-0.5 ${step < currentStep ? 'bg-dgd-gold/40' : 'bg-stone-800'}`}
              />
            )}
          </div>
        ))}
        <span className="ml-3 text-stone-400 text-sm">{stepLabel}</span>
      </div>
    </div>
  );
}
